import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ILeadStage } from "../leadStageModel";

export const getAllLeadStage = createAsyncThunk(
  "LeadStage/FindAllLeadStage",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/FindAllLeadStage`,
        {
          LeadStage: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lead Status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveLeadStage = createAsyncThunk(
  "LeadStage/FindAllActiveLeadStage",
  async (LeadStageType: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/FindAllActiveLeadStage`,
        {
          LeadStageType: LeadStageType,
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createLeadStage = createAsyncThunk(
  "LeadStage/InsertLeadStage",
  async (LeadStageData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/InsertLeadStage`,
        LeadStageData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateLeadStage = createAsyncThunk(
  "LeadStage/UpdateLeadStage",
  async (LeadStageData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/UpdateLeadStage`,
        LeadStageData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getLeadStageByID = createAsyncThunk(
  "LeadStage/FindByIDLeadStage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/FindByIDLeadStage`,
        {
          ID: ID,
        }
      );
      const result = response.data?.Data as any;
      return {
        ID: result?.ID,
        LeadStage: result?.LeadStage,
        LeadStageType: result?.LeadStageType,
        IsActive: result?.IsActive ? 1 : 2,
      } as ILeadStage;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveLeadStage = createAsyncThunk(
  "LeadStage/ActiveInActiveLeadStage",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/ActiveInActiveLeadStage`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteLeadStage = createAsyncThunk(
  "LeadStage/DeleteLeadStage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/LeadStage/DeleteLeadStage`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Lead Stage:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
